class PredictiveSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.getSearchDefault()
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)
    this.els.input.element.addEventListener('click', this.onClick)

    this.onClose = this.onClose.bind(this)
    this.els.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.onClose)
    })
    this.externalEls.backdrop.element.addEventListener('click', this.onClose)

    this.onTrigger = this.onTrigger.bind(this)
    this.externalEls.trigger.element.addEventListener('click', this.onTrigger)

    this.listeners.add(
      this.els.input.element,
      'input',
      window.BAO.Utils.debounce((e) => {
        this.onChange(e)
      }, 500).bind(this),
    )
  }

  hideAnimatedSearchText () {
    const el = document.querySelector('.hd-Search_Animation')

    if (!el) {
      return
    }

    document.querySelector('.hd-Search_Animation').style.display = 'none'
  }

  showAnimatedSearchText () {
    const el = document.querySelector('.hd-Search_Animation')

    if (!el) {
      return
    }

    document.querySelector('.hd-Search_Animation').style.display = 'block'
  }

  onClick () {
    this.open()
  }

  onClose () {
    this.close()
    this.showAnimatedSearchText()
  }

  onTrigger () {
    this.focusAndOpenKeyboard()
  }

  onChange () {
    const searchTerm = this.els.input.element.value.trim()

    this.hideDefault(true)
    this.hideResults(false)

    this.searchCount = null

    if (!searchTerm.length) {
      this.hideDefault(false)
      this.hideResults(true)
      this.showAnimatedSearchText()
      return
    } else {
      this.hideAnimatedSearchText()
    }

    this.getSearchCount(searchTerm)
      .then((count) => {
        this.getSearchResults(searchTerm)
        this.getProductSearch(searchTerm)
      })
      .catch((error) => {
        console.error('Error getting search count:', error)
        // Still render results even if count fails
        this.getSearchResults(searchTerm)
        this.getProductSearch(searchTerm)
      })
  }

  getSearchDefault () {
    window.BAO.sectionRenderer
      .fetch(
        'section-search',
        `${window.Shopify.routes.root}?view=predictive-search`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['section-search'],
        )

        const myself = newDOM.querySelector('#shopify-section-section-search')
          .childNodes[0]

        this.els.default.element.innerHTML = myself.outerHTML

        this.hideResults(true)
        this.hideDefault(false)
      })
      .catch(() => {})
  }

  getSearchResults (searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product,collection&resources[limit]=10&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        this.els.results.element.innerHTML = resultsMarkup

        // Update the count in the rendered results
        const countElement = this.els.results.element.querySelector(
          '[data-search-total-count]',
        )
        if (countElement && this.searchCount) {
          countElement.textContent = this.searchCount
          countElement.setAttribute('aria-hidden', 'false')
        }

        // eslint-disable-next-line no-undef
        yotpoWidgetsContainer.initWidgets()

        this.hideResults(false)
      })
      .catch((error) => {
        this.hideResults(true)
        this.hideDefault(false)
        throw error
      })
  }

  getProductSearch (searchTerm) {
    fetch(
      `/search/suggest.json?q=${searchTerm}&resources[type]=product,collection&resources[limit]=10`,
    )
      .then((response) => response.json())
      .then((suggestions) => {
        const productSuggestions = suggestions.resources.results.products
        const collectionSuggestions = suggestions.resources.results.collections

        if (
          productSuggestions.length === 0 &&
          collectionSuggestions.length === 0
        ) {
          this.hideDefault(false)
        }
      })
  }

  getSearchCount (searchTerm) {
    return window.BAO.sectionRenderer
      .fetch('search-count', `/search?q=${searchTerm}&type=product`)
      .then((res) => {
        const countElement = document.createElement('div')
        countElement.innerHTML = res['search-count']
        const countValue = countElement
          .querySelector('#search-count')
          .textContent.trim()

        this.searchCount = countValue

        return countValue
      })
      .catch((error) => {
        console.error('Error fetching search count:', error)
        this.searchCount = '0' // Fallback to 0 if error
        return '0'
      })
  }

  open () {
    this.els.search.element.setAttribute('aria-hidden', false)
    this.els.close?.elements.forEach((closeEl) => {
      closeEl.setAttribute('aria-hidden', false)
    })
    this.externalEls.banner.element.classList.add('hd-Header_Banner-active')
  }

  close () {
    this.els.search.element.setAttribute('aria-hidden', true)
    this.els.input.element.value = ''
    this.els.close?.elements.forEach((closeEl) => {
      closeEl.setAttribute('aria-hidden', true)
    })
    this.externalEls.banner.element.classList.remove('hd-Header_Banner-active')
  }

  hideResults (state) {
    this.els.results.element.setAttribute('aria-hidden', state)
  }

  hideDefault (state) {
    this.els.default.element.setAttribute('aria-hidden', state)
  }

  focusAndOpenKeyboard () {
    // Align temp input element approximately where the input element is
    // so the cursor doesn't jump around
    const tempInputEl = document.createElement('input')
    tempInputEl.style.position = 'absolute'
    tempInputEl.style.top = `${this.els.input.element.offsetTop + 7}px`
    tempInputEl.style.left = `${this.els.input.element.offsetLeft}px`
    tempInputEl.style.height = 0
    tempInputEl.style.opacity = 0
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(tempInputEl)
    tempInputEl.focus()

    // The keyboard is open. Now do a delayed focus on the target element
    window.setTimeout(() => {
      this.els.input.element.focus()
      this.els.input.element.click()
      // Remove the temp element
      document.body.removeChild(tempInputEl)
    }, 500)
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
